export default "__VITE_ASSET__x7$hG2ZW__"